export default `
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform vec3 uColor4;
uniform vec4 uRandom;
uniform vec4 uColorMap;
uniform float uTime;
uniform vec2 uResolution;

varying vec2 vUv;

void main(){

  vec2 st = gl_FragCoord.xy / uResolution.xy;
  float l = length(st - 0.5) * 2.0;
  float noise = snoise3D(vec3(vUv, uTime * 0.05 + uRandom.y * 10.0)) * 0.5 + 0.5;
  vec3 color;

  color = mix(uColor1, uColor2, smoothstep(0.0, uColorMap.x, noise));
  color = mix(color, uColor3, smoothstep(uColorMap.x, uColorMap.z, noise));
  color = mix(color, uColor4, smoothstep(uColorMap.y, 1.0, noise));

  vec3 hsv = rgb2hsv(color);
  hsv.x -= 0.03;
  hsv.g += mix(0.5, -0.1, smoothstep(0.1, 0.4, l));
  hsv.b += mix(0.0, 0.3, l);
  color = hsv2rgb(hsv);


  float alpha = 1.0;

  float uvl = length(vUv - 0.5) * 2.0;
  alpha = smoothstep(0.8, 0.0, uvl);

  alpha = alpha * 0.35 + pow(alpha, 6.0) * 0.3;

  gl_FragColor = vec4(color, alpha);
}
`
